import { List } from "antd";
import React, { useEffect, useState } from "react";
import styles from "./Inventory.module.css";
import { AntdSubmit } from "../../../../components";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ActiveJobsMiddleware from "../../../../store/Middlewares/ActiveJobsMiddleware";
import AlertAction from "../../../../store/Actions/AlertActions";
import { useTranslation } from "react-i18next";

const Inventory = () => {
  const [usedItem, setUsedItem] = useState(0);
  

  useEffect(() => {
    getLanguage();
    getActiveAndPastJobDetails();
  }, [])

  const getActiveAndPastJobDetails = () => {
    dispatch(ActiveJobsMiddleware.getActiveAndPastJobDetails(data?.id));
  };

  const getLanguage = async () => {
    try {
      const language = localStorage.getItem('@selectedLanguage');
      i18n.changeLanguage(language);
    } catch (e) {
      console.log(e);
    }
  };
  const location = useLocation();
  const data = location?.state

  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const [Refresh, setRefresh] = useState(false);
  const [multiInventory] = useState([]);

  console.log('=========', data?.id)

  const ActiveAndPastJobDetails = useSelector(
    state => state?.ActiveAndPastJobDetailsReducer?.ActiveAndPastJobDetailsList?.inventories);

  const onPressIncreaseQuantity = index => {
    
    if (
      ActiveAndPastJobDetails[index].quantity_used >= ActiveAndPastJobDetails[index].quantity
    ) {
    } else {
      ActiveAndPastJobDetails[index].quantity_used = parseInt(ActiveAndPastJobDetails[index].quantity_used) + 1;

      multiInventory.push({
        task_inventory_id: ActiveAndPastJobDetails[index].task_inventory_id,
        quantity_used: ActiveAndPastJobDetails[index].quantity_used,
      });
      setRefresh(!Refresh);
    }
  };

  const onPressDecreaseQuantity = index => {
    if (ActiveAndPastJobDetails[index].quantity_used <= 0) {
    } else {
      ActiveAndPastJobDetails[index].quantity_used =
        ActiveAndPastJobDetails[index].quantity_used - 1;
      setRefresh(!Refresh);
    }
  };

  const JobDetailsInventory = () => {
    let SomeData = {
      Job_id: data?.id,
      data: ActiveAndPastJobDetails,
    };
    dispatch(ActiveJobsMiddleware.JobDetailsInventory(SomeData))
      .then(data => {
        dispatch(AlertAction.ShowAlert({ type: "success", message: data?.message }))
      })
      .catch(err => {
        console.log(err);
      });
  };
  const renderItem = (item, index) => {
    return (
      <div className={styles.listitemRow}>
        <div className={styles.ColLeft}>
          <p>{item?.name}</p>
        </div>
        <div className={styles.ColRight}>
          <div className={styles.subColleft}>
            <button onClick={() => { onPressDecreaseQuantity(index); }}
              className={styles.button}>-</button>
            <div className={styles.usedDiv}>
              <input
                value={item?.quantity_used ? item?.quantity_used : '0'}
              // onChange={(e) => setUsedItem(e.target.value)}
              />
              <p>Used</p>
            </div>
            <button onClick={() => { onPressIncreaseQuantity(index); }}
              className={styles.button}>+</button>
          </div>
          <div className={styles.subColRight}>
            <span>{item?.quantity}</span>
            <p>Total</p>
          </div>
        </div>
      </div>
    );
  };
  return (
    <>
      <div className={styles.list}>
        <List
          style={{ width: "100%" }}
          // grid={{ xs: 1, sm: 1, md: 3, lg: 3, xl: 4, xxl: 4 }}
          dataSource={ActiveAndPastJobDetails}
          renderItem={renderItem}
        />
      </div>
      {ActiveAndPastJobDetails?.length > 0 ?
      <div className={styles.btn}>
      <AntdSubmit
            onClick={JobDetailsInventory}
            text={t('Update Inventory')}
            buttonStyle={{ margin: "15px 0px", height: "60px", width: '100%' }}
      />
      </div>
        : null}
    </>
  );
};

export default Inventory;
